// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__16aJX","col":"styles_col__3ujfT"};